export const REQUEST_REASONS = [
  'Engine Problems',
  'Starter Motor Issues',
  'Engine Overheating',
  'Engine Failures',
  'Radiator Leaks',
  'Battery Issues',
  'Gear Issues',
  'Tire Flats',
  'Electrical Issues',
  'Timing Belt Failures',
  'Alternator / Dynamo',
] as const;

export type RequestReason = typeof REQUEST_REASONS[number];














